module.exports = __webpack_public_path__ + "static/media/utsav-img.16e4793a.jpg";